import dotPropImmutable from 'dot-prop-immutable';
import uniq from 'lodash/uniq';
import { ResourceSectionType } from 'data/documents';
export const documentTemplateResourceSlice = {
    createDocumentResourceSection: (state, { payload })=>{
        var _sections_find;
        const { docId, resourceSectionId, resourceSectionName, resourceType, sectionId: _sectionId } = payload;
        const sections = Object.values(dotPropImmutable.get(state, `${docId}.sections`, {}));
        const sectionId = _sectionId !== undefined ? _sectionId : (_sections_find = sections.find((section)=>{
            return section.meta.sectionType === 'PUBLIC';
        })) === null || _sections_find === void 0 ? void 0 : _sections_find.documentSectionId;
        const newResourceSection = {
            resourceSectionId,
            resourceSectionName,
            resourceSectionType: ResourceSectionType.Task,
            resourceType,
            resourceIds: [],
            resourceObjects: []
        };
        const resourceSectionIds = dotPropImmutable.get(state, `${docId}.sections.${sectionId}.meta.resourceSections`, []);
        let result = dotPropImmutable.set(state, `${docId}.sections.${sectionId}.meta.resourceSections`, uniq([
            ...resourceSectionIds,
            resourceSectionId
        ]));
        result = dotPropImmutable.merge(result, `${docId}.resourceSections.${resourceSectionId}`, newResourceSection);
        return result;
    },
    updateDocumentResourceSection: (state, { payload })=>{
        const { docId, resource } = payload;
        return dotPropImmutable.merge(state, `${docId}.resourceSections.${resource.resourceSectionId}`, resource);
    }
};
